export default "__VITE_ASSET__C9mJiW3O__"